export const navItems = [
  { path: '/', label: 'About' },
  { path: '/contact', label: 'Contact' },
];
